import { render } from "./CheckboxList.vue?vue&type=template&id=53fe64ae&scoped=true"
import script from "./CheckboxList.vue?vue&type=script&lang=js"
export * from "./CheckboxList.vue?vue&type=script&lang=js"

import "./CheckboxList.vue?vue&type=style&index=0&id=53fe64ae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53fe64ae"]])

export default __exports__